import { render, staticRenderFns } from "./AdminDetailedSales.vue?vue&type=template&id=29b967ea"
import script from "./AdminDetailedSales.vue?vue&type=script&lang=js"
export * from "./AdminDetailedSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports